<template>
  <DealDetail :deal="deal"/>
</template>

<script>
// @ is an alias to /src
import DealDetail from '@/components/DealDetail.vue';
import axios from 'axios';

export default {
  name: 'feed',
  components: {
    DealDetail,
  },
  beforeCreate() {
    this.$Amplify.Auth.currentAuthenticatedUser()
    .then(user => {
      this.$logger.debug('signed in');
      this.signedIn = true;
      this.user = user;
    }).catch(() => {
      this.$logger.debug('not signed in');
      this.signedIn = false;
      this.$router.push('/');
    });
  },
  data() {
    return {
      signedIn: false,
      user: {},
      deal: {},
    };
  },
  mounted () {
    if (this.$store.state.signedIn) {
      axios
        .get(process.env.VUE_APP_API_FEED_BASE + '/deals/' + this.$route.params.id, { headers: { Authorization: `Bearer ${this.$store.state.user.signInUserSession.getIdToken().getJwtToken()}`}} )
        .then(response => (this.deal = response.data))
    }
  }
};
</script>
